import { Avatar, styled } from '@mui/material';
import { useEffect, useState } from 'react';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.primary.main,
}));

type Props = {
  username: string;
  size?: number;
};

const UserAvatar = ({ username, size = 35 }: Props) => {
  const [initials, setInitials] = useState(' ');
  const [color, setColor] = useState(' ');

  useEffect(() => {
    if (username) {
      if (username) {
        const nameParts = username.toLocaleUpperCase().split(' ');
        setInitials(nameParts.length > 1 ? `${nameParts[0][0]}${nameParts[1][0]}` : nameParts[0][0]);
        setColor(stringToColor(username));
      }
    }
  }, [username]);

  const stringToColor = (username: string) => {
    let hash = 0;

    for (let i = 0; i < username.length; i += 1) {
      hash = username.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (let i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  };

  return (
    <StyledAvatar
      sx={{
        padding: 1,
        width: size,
        height: size,
        fontSize: '14px',
      }}
    >
      {initials}
    </StyledAvatar>
  );
};

export default UserAvatar;
